import { useSwrMutationApi } from 'src/hooks/useSwrApi/useSwrMutationApi';

interface UseSwrHireGuaranteeCheckoutProps {
  locale: string;
  successCallback?: (response: ApiSchema<'CheckoutDataRead'>) => void | Promise<void>;
  errorCallback?: () => void;
}

export const useSwrHireGuaranteeCheckout = (props: UseSwrHireGuaranteeCheckoutProps) => {
  const { locale, successCallback, errorCallback } = props;

  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<ApiSchema<'CheckoutDataRead'>, undefined>({
    url: '/v1/hire/hire-guarantee',
    locale,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
    },
    apiOptions: {
      onSuccess: (response) => {
        if (successCallback) { void successCallback(response); }
      },
      onError: () => {
        if (errorCallback) errorCallback();
      },
    },
    toastsOptions: {
      showErrorToast: true,
    },
  });

  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};

